import Link from "next/link";
import { useTranslation } from "next-i18next";
import { TranslationKeys } from "src/@types/i18next";
import Logo from "@common/components/Logo";

const homeLinks: { href: string; label: TranslationKeys["common"] }[] = [
  { href: "/", label: "common:get_started" },
  { href: "/#how-it-works", label: "common:how_it_works" },
];

const throttleLinks: { href: string; label: TranslationKeys["common"] }[] = [
  { href: "/about#our-values", label: "common:our_values" },
  { href: "/about#our-story", label: "common:our_story" },
  { href: "/about#locations", label: "common:locations" },
];

const contactLinks: { href: string; label: TranslationKeys["common"] }[] = [
  { href: "/contact#support", label: "common:support" },
];

const currentYear = new Date().getFullYear();

const Footer = () => {
  const { t } = useTranslation(["common"]);

  return (
    <footer className="bg-primary-950 px-4 lg:px-24 py-6">
      <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between lg:pt-4 lg:pb-16">
        <Link href="/" className="lg:order-last">
          <Logo className="w-36 h-12 text-white hover:text-primary-100" />
        </Link>
        <div className="flex flex-col gap-2 mt-6 lg:mt-0">
          <Link href="/" className="text-gray-300">
            {t("common:home")}
          </Link>
          {homeLinks.map(({ href, label }) => (
            <Link
              key={href}
              href={href}
              className="text-white hover:text-opacity-80"
            >
              {t(label)}
            </Link>
          ))}
        </div>
        <div className="flex flex-col gap-2 mt-6 lg:my-0">
          <Link href="about" className="text-gray-300">
            {t("common:why_throttle")}
          </Link>
          {throttleLinks.map(({ href, label }) => (
            <Link
              key={href}
              href={href}
              className="text-white hover:text-opacity-80"
            >
              {t(label)}
            </Link>
          ))}
        </div>
        <div className="flex flex-col gap-2 my-8 lg:my-0">
          <Link href="/contact" className="text-gray-300">
            {t("common:contact_us")}
          </Link>
          {contactLinks.map(({ href, label }) => (
            <Link
              key={href}
              href={href}
              className="text-white hover:text-opacity-80"
            >
              {t(label)}
            </Link>
          ))}
        </div>
      </div>
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between border-t border-gray-500">
        <div className="flex flex-wrap gap-8 py-8">
          <Link
            href="/terms-conditions"
            className="text-white hover:text-opacity-80"
          >
            {t("common:terms_of_service")}
          </Link>
          <Link
            href="/privacy-policy"
            className="text-white hover:text-opacity-80"
          >
            {t("common:privacy_policy")}
          </Link>
        </div>
        <p className="text-white">
          © {currentYear} Throttle. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
